import './assets/css/main.css';
import './Partials/icon';
import '@bpmlib/vue-satoast/style.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FloatingVue from 'floating-vue';
import i18n from '@/assets/i18n/i18n';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';

const app = createApp(App);

if (import.meta.env.VITE_SENTRY_DSN) {
  const integrations = [];
  if (import.meta.env.VITE_SENTRY_TRACING) integrations.push(Sentry.browserTracingIntegration({ router }));
  if (import.meta.env.VITE_SENTRY_REPLAY) integrations.push(Sentry.replayIntegration());

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations,
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/srf\.superapp\.ppsdmmigas\.id\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(FloatingVue);
app.component('FontAwesomeIcon', FontAwesomeIcon);

app.mount('#app');
